<template>
  <transition>
    <header
      v-show="showHeaderScrollNavi && isPcPreview"
      class="header scroll-navi"
    >
      <nav class="global_navi preview sp-hide">
        <div class="inner flex flex-align">
          <p
            v-if="isPankuzuList"
            class="pankuzu_list flex flex-align"
          >
            <a
              class="preview_enabled return_to_edit_button white"
              :href="editUrl"
            >
              <span>プレスリリース作成（編集）画面に戻る</span>
            </a>
          </p>
          <p class="edit_preview_title">
            プレビュー画面
          </p>
        </div>
      </nav>
      <nav class="global_navi pc_sp_switch sp-hide">
        <div class="inner flex flex-align">
          <ul class="pankuzu_list flex preview-icon-flex-align pc_sp_switch_item_list">
            <li
              id="show-sp-preview"
              class="show_sp_preview"
              @click="showSpPreview"
            >
              <p class="pc_sp_switch_item">
                スマホプレビュー
              </p>
            </li>
            <li
              id="show-pc-preview"
              class="show_pc_preview active"
              @click="showPcPreview"
            >
              <p class="pc_sp_switch_item">
                PCプレビュー
              </p>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  </transition>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: ""
    },
    editUrl: {
      type: String,
      default: ""
    },
    showHeaderScrollNavi: {
      type: Boolean,
      default: false
    },
    isPcPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    isPankuzuList() {
      return this.status === "draft";
    },
  },
  methods: {
    showPcPreview() {
      this.$emit("show-pc-preview");
    },
    showSpPreview() {
      this.$emit("show-sp-preview");
    }
  }
};
</script>

<style lang="scss" scoped>
  #articles_new .header {
    padding: 0;
    margin: 0;
  }

  .scroll-navi {
    position: fixed !important;
    top: 0 !important;
    z-index: 99999 !important;
  }

  #articles_new .global_navi {
    margin-top: 0;
  }

  .v-leave-active {
    transition: opacity .3s;
  }

  .v-enter-active {
    transform: translate(0px, 0px);
    transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  }

  .v-enter {
    transform: translateY(-100px) translateY(0px);
  }

  .v-leave-to {
    opacity: 0;
  }
</style>
